// extracted by mini-css-extract-plugin
export default {"rating":"NB-z","numberOfStars":"OB-z","count":"PB-z","barGraphSpacing":"QB-z","barGraph":"RB-z"};